import { QFilterGeneric } from './QFilterGeneric'

export class QFilterSortDesc extends QFilterGeneric {
  name = "sort_desc";
  class_name = "QFilterSortDesc";
  api_name = null;//'sort_order';

  constructor(value) {
    if (value)  {
      super(value);
    } else {
      super(false);
    }
  }

  short() {
    return this.value ? 'desc' : 'asc';
  }

  serialize(qfilters) {
    return this.value ? 'D' : 'A';
  }
  
}
